/* Generated. This file cannot be edited directly. Please check codegen-subscription.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/subscriptionTypes'

const defaultOptions = {} as const
export type BookabilityCardVehicleTelemetrySubscriptionVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
}>

export type BookabilityCardVehicleTelemetrySubscription = {
  __typename?: 'Subscription'
  fccVehicleTelemetry: {
    __typename?: 'FccVehicleTelemetry'
    missionConnectivity: {
      __typename?: 'FccAdConnectivity'
      connectivityState: Types.FccAdConnectivityState
      timestamp: string
    } | null
  }
}

export const BookabilityCardVehicleTelemetryDocument = gql`
    subscription BookabilityCardVehicleTelemetry($vehicleId: ID!) {
  fccVehicleTelemetry(vehicleId: $vehicleId) {
    missionConnectivity {
      connectivityState
      timestamp
    }
  }
}
    `

/**
 * __useBookabilityCardVehicleTelemetrySubscription__
 *
 * To run a query within a React component, call `useBookabilityCardVehicleTelemetrySubscription` and pass it any options that fit your needs.
 * When your component renders, `useBookabilityCardVehicleTelemetrySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookabilityCardVehicleTelemetrySubscription({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useBookabilityCardVehicleTelemetrySubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    BookabilityCardVehicleTelemetrySubscription,
    BookabilityCardVehicleTelemetrySubscriptionVariables
  > &
    (
      | {
          variables: BookabilityCardVehicleTelemetrySubscriptionVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    BookabilityCardVehicleTelemetrySubscription,
    BookabilityCardVehicleTelemetrySubscriptionVariables
  >(BookabilityCardVehicleTelemetryDocument, options)
}
export type BookabilityCardVehicleTelemetrySubscriptionHookResult = ReturnType<
  typeof useBookabilityCardVehicleTelemetrySubscription
>
export type BookabilityCardVehicleTelemetrySubscriptionResult =
  Apollo.SubscriptionResult<BookabilityCardVehicleTelemetrySubscription>
